import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CookiesImage } from 'images/svg';
import { Grid, Typography, makeStyles, Link } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { ButtonActions } from 'Components/UI';
import { useAtom } from 'jotai';
import { cookiesAtom, displayCookiesAtom, staticDataAtom } from 'Atoms/Common';
import { ticketAtom } from 'Atoms/Ticket';
import { postRenewCookie } from 'utils';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.containerGrid,
    textAlign: 'center',
    padding: '1.5rem 1rem',
    maxheight: '80%',
    margin: '1rem',
    boxShadow: '0 7px 20px rgba(255, 255, 255, 0.3)',
    borderRadius: '15px',
    backgroundColor: '#fff',
    '& button ': {
      boxShadow: 'none',
      '& p': {
        fontSize: '15px',
      },
    },
  },
  subHeader: {
    margin: '1rem',
  },
  important: {
    fontWeight: 'bold',
  },
  title: { ...theme.title, fontSize: '25px' },
  otherActions: {
    marginBottom: '9rem',
  },
}));
const Cookies = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [cookies, setCookies] = useAtom(cookiesAtom);
  const [displayCookies, setDisplayCookies] = useAtom(displayCookiesAtom);
  const [ticket] = useAtom(ticketAtom);
  const [staticData] = useAtom(staticDataAtom);
  const [
    displayCookiesReloadForm,
    setDisplayMessageRealodCookiesForm,
  ] = useState(false);
  const [disabledHover, setDisabledHover] = useState(true);

  const handleCookiesAction = async (e, bool) => {
    if (!bool) {
      setDisabledHover(true);
      setDisplayMessageRealodCookiesForm(true);
    } else {
      const ticketAlias = ticket?.id;
      const idSession = staticData?.idSession;
      postRenewCookie(ticketAlias, idSession);
      setCookies(true);
      setDisplayCookies(false);
      setDisabledHover(false);
    }
  };
  const handleReloadCookie = (e, bool) => {
    e.preventDefault();
    setDisabledHover(false);
    setTimeout(() => {
      setDisplayMessageRealodCookiesForm(bool);
    }, 250);
  };

  return (
    <Grid
      container
      direction="column"
      justifyContent="space-evenly"
      alignContent="center"
      alignItems="center"
      className={classes.root}
    >
      <Grid item>
        <Grid
          container
          direction="column"
          alignContent="center"
          alignItems="center"
        >
          <Grid item>
            <CookiesImage />
          </Grid>
          <Grid item className={classes.subHeader}>
            <Typography variant="h1" className={classes.title}>
              {t('welcome_pay_on_table')}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>{t('pay_on_table_services_cookies')}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {displayCookiesReloadForm && (
          <Grid
            container
            direction="column"
            justifyContent="space-between"
            alignContent="center"
            alignItems="center"
          >
            <Grid item>
              <Link
                data-testid="reloadCookies"
                onClick={(e) => handleReloadCookie(e, false)}
              >
                <ButtonActions
                  label={t('reload_cookies_form')}
                  color="default"
                  styles={{
                    background: 'backgroundGreenCookies',
                    label: 'labelGreen',
                    border: 'borderGreen',
                    radius: 'radius33',
                  }}
                />
              </Link>
            </Grid>
          </Grid>
        )}
        {!displayCookiesReloadForm && (
          <Grid
            container
            direction="column"
            justifyContent="space-between"
            alignContent="center"
            alignItems="center"
          >
            <Grid item>
              <Link
                data-testid="agreeCookie"
                onClick={(e) => handleCookiesAction(e, true)}
              >
                <ButtonActions
                  label={t('understand_continue')}
                  color="default"
                  styles={{
                    background: 'backgroundGreenCookies',
                    label: 'labelGreen',
                    border: 'borderGreen',
                    radius: 'radius33',
                    hover: disabledHover,
                  }}
                />
              </Link>
            </Grid>
            <Grid item>
              <Link
                onClick={(e) => handleCookiesAction(e, false)}
                data-testid="refuse_use_service"
              >
                <ButtonActions
                  label={t('refuse_use_service')}
                  color="default"
                  styles={{
                    background: 'backgroundWhiteCookies',
                    label: 'labelDark',
                    border: 'borderDark',
                    radius: 'radius33',
                    hover: disabledHover,
                  }}
                />
              </Link>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

Cookies.propTypes = {};

export default Cookies;
